import test from '../../images/bg/webp/bg-3-pet-avatar.webp'

export const NavLinkSite = {
  collection: 'Collections',
  roadmap: 'Roadmap',
  tokenomic: 'Tokenomic',
  docs: 'Docs',
  social: 'Social',
}

export const RightNavFourElements = {
  title: 'Social',
  icon: '<FaAlignLeft />',
  child: {
    fb: {
      label: 'Facebook',
      icon: '<FaFacebookSquare/>',
      link: '',
    },
    tele: {
      label: 'Telegram',
      icon: '<FaTelegram />',
      link: '//t.me/Kittencity',
    },
    teleChat: {
      label: 'Chat',
      icon: '<FaTelegram />',
      link: '//t.me/Kittencity',
    },
    youtube: {
      label: 'Youtube',
      icon: '<FaYoutube />',
      link: '',
    },
    whitepaper: {
      label: 'Whitepaper',
      icon: '<FaFileAlt />',
      link: '//docs.kittencity.fun'
    },
    pitchdesk: {
      label: 'Pitch Desk',
      icon: '<FaFileAlt />',
      link: '../../files/KittenCityPD.pdf'
    },
    audit: {
      label: 'Audit Papper',
      icon: '<FaReddit />',
      link: '',
    },
    reddit: {
      label: 'Reddit',
      icon: '<FaReddit />',
      link: '',
    },
    twitter: {
      label: 'Twitter',
      icon: '<FaReddit />',
      link: '//twitter.com/kittencity_',
    },
    medium: {
      label: 'Medium',
      icon: '<FaReddit />',
      link: '',
    },
  },
}
export const Logo = {
  img: test,
}